import { render, staticRenderFns } from "./AlertsManager.vue?vue&type=template&id=4902b52f&scoped=true"
import script from "./AlertsManager.vue?vue&type=script&lang=js"
export * from "./AlertsManager.vue?vue&type=script&lang=js"
import style0 from "./AlertsManager.vue?vue&type=style&index=0&id=4902b52f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4902b52f",
  null
  
)

export default component.exports